import { Navigate, useLocation } from 'react-router-dom';

import { resolveBillingV2SplitTarget } from '@/lib/navigation/billing-destination';

export function BillingV2SplitRedirect() {
  const location = useLocation();
  return <Navigate replace to={resolveBillingV2SplitTarget(location)} />;
}
